define(
  'app/views/login_register_view',[
    'app/setup', 'app/views/gender_selector_view'
], function(
  takhfifan, genderSelectorView) {

  takhfifan.LoginRegisterView = Backbone.View.extend({

    events: {
      'click .tkh-login-button': 'triggerLoginForm',
      'click .tkh-register-button': 'triggerRegisterForm'
    },

    initialize: function() {
      var _this = this;

      takhfifan.eventHub.on('customer:login', function() {
        if ($('.tkh-shipping:visible').length == 0 &&
            $('.tkh-payment:visible').length == 0) {
          document.location.reload(true);
        } else {
          _this.$el.hide();
          if ($('.tkh-shipping').length > 0) {
            takhfifan.eventHub.trigger('checkout:shipping');
          } else {
            takhfifan.eventHub.trigger('checkout:payment');
          }
        }
      }, this);

      takhfifan.eventHub.on('customer:registerFormBack', function() {
        _this.$el.show();
      }, this);

    },

    triggerLoginForm: function(event) {
      event.preventDefault();
      takhfifan.eventHub.trigger('customer:loginForm');
    },

    triggerRegisterForm: function(event) {
      event.preventDefault();
      this.$el.hide();
      takhfifan.eventHub.trigger('customer:registerForm');
    }

  });

  $('.tkh-login-register').each(function(){
    new takhfifan.LoginRegisterView({ el: $(this) });
  });

});

